// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Pervasives from "../../../../node_modules/rescript/lib/es6/pervasives.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Product$Showside from "./Product.bs.js";
import * as Currency$Showside from "../utils/Currency.bs.js";
import * as AudioCard$Showside from "../components/AudioCard.bs.js";
import * as MakerPage$Showside from "../components/MakerPage.bs.js";
import * as CustomScript$Showside from "../utils/CustomScript.bs.js";
import * as ProductRulesConfig$Showside from "./ProductRulesConfig.bs.js";
import * as ProductDetailsConfigId$ApiTypes from "../../../../node_modules/api-types/lib/es6_global/src/ProductDetailsConfigId.bs.js";
import * as HtmlWithUnsafeJavascriptExecution$Showside from "../utils/HtmlWithUnsafeJavascriptExecution.bs.js";
var Visible = {};
function isVisible(product, variant, visible) {
  if (typeof visible === "number") {
    return visible === 0;
  } else if (variant !== undefined) {
    return ProductRulesConfig$Showside.matchesProduct(visible._0, product, variant);
  } else {
    return false;
  }
}
var DynamicSource = {};
var $$Image = {};
var Table = {};
function getId(t) {
  return t._0.id;
}
function getDynamicSource(t) {
  if (t.TAG === /* DynamicSource */0) {
    return t._0.source;
  }
}
function getImageSource(t) {
  if (t.TAG === /* Image */2) {
    return t._0.source;
  }
}
function getImageAltTextSource(t) {
  if (t.TAG === /* Image */2) {
    return t._0.altText;
  }
}
function renderText(isRichText, isPreWrapped, className, style, product, variant, string) {
  if (isRichText) {
    return React.createElement(HtmlWithUnsafeJavascriptExecution$Showside.make, {
      tag: /* P */1,
      style: style,
      className: Cn.make([CSS$Showside.prefix("m-0 select-text"), isPreWrapped ? CSS$Showside.prefix("whitespace-pre-wrap") : "", className]),
      children: string.replace(/\\\r/g, "\r").replace(/\\\n/g, "\n").replace(/\\\t/g, "\t").replace(/\$\{product\.id\}/g, product.id).replace(/\$\{variant\.id\}/g, Belt_Option.mapWithDefault(variant, "", function (variant) {
        return variant.id;
      })),
      key: Product$Showside.getKey(variant, product)
    });
  } else {
    return React.createElement("p", {
      key: Product$Showside.getKey(variant, product),
      className: Cn.make([CSS$Showside.prefix("select-text"), isPreWrapped ? CSS$Showside.prefix("whitespace-pre-wrap") : "", className]),
      style: style
    }, string);
  }
}
function renderTextList(isRichText, isPreWrapped, className, style, product, variant, list) {
  return React.createElement("p", undefined, React.createElement("ul", undefined, Belt_Array.mapWithIndex(list, function (i, text) {
    return React.createElement("li", {
      key: String(i)
    }, renderText(isRichText, isPreWrapped, className, style, product, variant, text));
  })));
}
function resolveMetaData(field, product, variant) {
  var variant$1 = Belt_Option.getWithDefault(variant, product.firstVariant);
  return Belt_Option.flatMap(Product$Showside.Metadata.getMetadataValue(product, variant$1, field), function (metadata) {
    var exit = 0;
    if (typeof metadata === "number") {
      return;
    }
    switch (metadata.TAG | 0) {
      case /* DecimalField */2:
        var arg = metadata._0.toString();
        return function (param) {
          return function (param$1) {
            var func = function (param$2, param$3, param$4, param$5, param$6) {
              return renderText(param, param$1, param$2, param$3, param$4, param$5, param$6);
            };
            return function (param) {
              var func$1 = Curry._1(func, param);
              return function (param) {
                var func$2 = Curry._1(func$1, param);
                return function (param) {
                  var func$3 = Curry._1(func$2, param);
                  return function (param) {
                    return Curry._2(func$3, param, arg);
                  };
                };
              };
            };
          };
        };
      case /* IntegerField */3:
        var arg$1 = metadata._0.toString();
        return function (param) {
          return function (param$1) {
            var func = function (param$2, param$3, param$4, param$5, param$6) {
              return renderText(param, param$1, param$2, param$3, param$4, param$5, param$6);
            };
            return function (param) {
              var func$1 = Curry._1(func, param);
              return function (param) {
                var func$2 = Curry._1(func$1, param);
                return function (param) {
                  var func$3 = Curry._1(func$2, param);
                  return function (param) {
                    return Curry._2(func$3, param, arg$1);
                  };
                };
              };
            };
          };
        };
      case /* Boolean */8:
        var arg$2 = Pervasives.string_of_bool(metadata._0);
        return function (param) {
          return function (param$1) {
            var func = function (param$2, param$3, param$4, param$5, param$6) {
              return renderText(param, param$1, param$2, param$3, param$4, param$5, param$6);
            };
            return function (param) {
              var func$1 = Curry._1(func, param);
              return function (param) {
                var func$2 = Curry._1(func$1, param);
                return function (param) {
                  var func$3 = Curry._1(func$2, param);
                  return function (param) {
                    return Curry._2(func$3, param, arg$2);
                  };
                };
              };
            };
          };
        };
      case /* Json */9:
        var arg$3 = JSON.stringify(metadata._0);
        return function (param) {
          return function (param$1) {
            var func = function (param$2, param$3, param$4, param$5, param$6) {
              return renderText(param, param$1, param$2, param$3, param$4, param$5, param$6);
            };
            return function (param) {
              var func$1 = Curry._1(func, param);
              return function (param) {
                var func$2 = Curry._1(func$1, param);
                return function (param) {
                  var func$3 = Curry._1(func$2, param);
                  return function (param) {
                    return Curry._2(func$3, param, arg$3);
                  };
                };
              };
            };
          };
        };
      case /* Money */10:
        var money = metadata._0;
        var arg$4 = Belt_Option.mapWithDefault(Currency$Showside.parse(money.currencyCode + money.amount), "", Currency$Showside.format);
        return function (param) {
          return function (param$1) {
            var func = function (param$2, param$3, param$4, param$5, param$6) {
              return renderText(param, param$1, param$2, param$3, param$4, param$5, param$6);
            };
            return function (param) {
              var func$1 = Curry._1(func, param);
              return function (param) {
                var func$2 = Curry._1(func$1, param);
                return function (param) {
                  var func$3 = Curry._1(func$2, param);
                  return function (param) {
                    return Curry._2(func$3, param, arg$4);
                  };
                };
              };
            };
          };
        };
      case /* Dimension */4:
      case /* Volume */11:
      case /* Weight */12:
        exit = 2;
        break;
      case /* MultiLineTextField */0:
      case /* SingleLineTextField */1:
      case /* Date */5:
      case /* DateTime */6:
      case /* Color */7:
      case /* Url */13:
      case /* Rating */14:
        exit = 1;
        break;
      case /* FileReference */15:
        var fileType = metadata._0;
        var arg$5;
        arg$5 = fileType.TAG === /* TypeImage */0 ? fileType._0.url : Belt_Option.getWithDefault(fileType._0.poster, "");
        return function (param) {
          return function (param$1) {
            var func = function (param$2, param$3, param$4, param$5, param$6) {
              return renderText(param, param$1, param$2, param$3, param$4, param$5, param$6);
            };
            return function (param) {
              var func$1 = Curry._1(func, param);
              return function (param) {
                var func$2 = Curry._1(func$1, param);
                return function (param) {
                  var func$3 = Curry._1(func$2, param);
                  return function (param) {
                    return Curry._2(func$3, param, arg$5);
                  };
                };
              };
            };
          };
        };
      case /* Audio */16:
        var match = metadata._0;
        var thumbnailUrl = match.thumbnailUrl;
        var contentUrl = match.contentUrl;
        var name = match.name;
        return function (isRichText, isPreWrapped, className, style, product, variant) {
          return React.createElement(AudioCard$Showside.make, {
            contentUrl: contentUrl,
            thumbnailUrl: thumbnailUrl,
            name: name
          });
        };
      case /* ListColor */17:
      case /* ListSingleLineTextField */21:
      case /* ListUrl */22:
        exit = 3;
        break;
      default:
        return;
    }
    switch (exit) {
      case 1:
        var string = metadata._0;
        if (!Product$Showside.Metadata.isEmpty(string)) {
          return function (param) {
            return function (param$1) {
              var func = function (param$2, param$3, param$4, param$5, param$6) {
                return renderText(param, param$1, param$2, param$3, param$4, param$5, param$6);
              };
              return function (param) {
                var func$1 = Curry._1(func, param);
                return function (param) {
                  var func$2 = Curry._1(func$1, param);
                  return function (param) {
                    var func$3 = Curry._1(func$2, param);
                    return function (param) {
                      return Curry._2(func$3, param, string);
                    };
                  };
                };
              };
            };
          };
        } else {
          return;
        }
      case 2:
        var physicalQuantity = metadata._0;
        var arg$6 = physicalQuantity.value.toString() + " " + physicalQuantity.unitName;
        return function (param) {
          return function (param$1) {
            var func = function (param$2, param$3, param$4, param$5, param$6) {
              return renderText(param, param$1, param$2, param$3, param$4, param$5, param$6);
            };
            return function (param) {
              var func$1 = Curry._1(func, param);
              return function (param) {
                var func$2 = Curry._1(func$1, param);
                return function (param) {
                  var func$3 = Curry._1(func$2, param);
                  return function (param) {
                    return Curry._2(func$3, param, arg$6);
                  };
                };
              };
            };
          };
        };
      case 3:
        var list = metadata._0;
        if (!Product$Showside.Metadata.isEmptyList(list)) {
          return function (param) {
            return function (param$1) {
              var func = function (param$2, param$3, param$4, param$5, param$6) {
                return renderTextList(param, param$1, param$2, param$3, param$4, param$5, param$6);
              };
              return function (param) {
                var func$1 = Curry._1(func, param);
                return function (param) {
                  var func$2 = Curry._1(func$1, param);
                  return function (param) {
                    var func$3 = Curry._1(func$2, param);
                    return function (param) {
                      return Curry._2(func$3, param, list);
                    };
                  };
                };
              };
            };
          };
        } else {
          return;
        }
    }
  });
}
function resolveProductData(dataType, product, variant) {
  var result;
  switch (dataType) {
    case /* ProductTitle */0:
      result = product.name;
      break;
    case /* ProductDescription */1:
      result = Belt_Option.orElse(Belt_Option.flatMap(variant, function (v) {
        return v.description;
      }), product.description);
      break;
    case /* ProductPrice */2:
      result = Belt_Option.map(variant, function (variant) {
        return Product$Showside.Variant.getVariantPrices(variant)[0];
      });
      break;
    case /* ProductSalePrice */3:
      result = Belt_Option.flatMap(variant, function (variant) {
        return Product$Showside.Variant.getVariantPrices(variant)[1];
      });
      break;
    case /* ProductSKU */4:
      result = Belt_Option.flatMap(variant, function (variant) {
        return variant.sku;
      });
      break;
    case /* ProductId */5:
      result = product.id;
      break;
    case /* VariantId */6:
      result = Belt_Option.map(variant, function (v) {
        return v.id;
      });
      break;
  }
  return Belt_Option.map(Belt_Option.keep(result, function (string) {
    return !Product$Showside.Metadata.isEmpty(string);
  }), function (string) {
    return function (param) {
      return function (param$1) {
        var func = function (param$2, param$3, param$4, param$5, param$6) {
          return renderText(param, param$1, param$2, param$3, param$4, param$5, param$6);
        };
        return function (param) {
          var func$1 = Curry._1(func, param);
          return function (param) {
            var func$2 = Curry._1(func$1, param);
            return function (param) {
              var func$3 = Curry._1(func$2, param);
              return function (param) {
                return Curry._2(func$3, param, string);
              };
            };
          };
        };
      };
    };
  });
}
function getCustomLabelText(index, variant) {
  return Belt_Option.flatMap(variant, function (variant) {
    return Belt_Array.get(variant.customLabels, index);
  });
}
function resolveCustomLabel(index, variant) {
  return Belt_Option.map(Belt_Option.keep(Belt_Option.flatMap(variant, function (variant) {
    return Belt_Array.get(variant.customLabels, index);
  }), function (string) {
    return !Product$Showside.Metadata.isEmpty(string);
  }), function (string) {
    return function (param) {
      return function (param$1) {
        var func = function (param$2, param$3, param$4, param$5, param$6) {
          return renderText(param, param$1, param$2, param$3, param$4, param$5, param$6);
        };
        return function (param) {
          var func$1 = Curry._1(func, param);
          return function (param) {
            var func$2 = Curry._1(func$1, param);
            return function (param) {
              var func$3 = Curry._1(func$2, param);
              return function (param) {
                return Curry._2(func$3, param, string);
              };
            };
          };
        };
      };
    };
  });
}
function resolveAvailability(availabilityContent, product, variant) {
  var outOfStockText = availabilityContent.outOfStockText;
  var inStockText = availabilityContent.inStockText;
  return Belt_Option.map(Belt_Option.mapWithDefault(variant, Product$Showside.isOutOfStock(product) ? outOfStockText : inStockText, function (variant) {
    var match = variant.availability;
    if (match) {
      return inStockText;
    } else {
      return outOfStockText;
    }
  }), function (string) {
    return function (param) {
      return function (param$1) {
        var func = function (param$2, param$3, param$4, param$5, param$6) {
          return renderText(param, param$1, param$2, param$3, param$4, param$5, param$6);
        };
        return function (param) {
          var func$1 = Curry._1(func, param);
          return function (param) {
            var func$2 = Curry._1(func$1, param);
            return function (param) {
              var func$3 = Curry._1(func$2, param);
              return function (param) {
                return Curry._2(func$3, param, string);
              };
            };
          };
        };
      };
    };
  });
}
function renderImage(src, alt) {
  if (src === undefined) {
    return;
  }
  var tmp = {
    className: CSS$Showside.prefix("w-full"),
    src: src
  };
  if (alt !== undefined) {
    tmp.alt = Caml_option.valFromOption(alt);
  }
  return Caml_option.some(React.createElement("img", tmp));
}
function renderContentFragment(id, element) {
  return React.createElement(React.Fragment, {
    children: element,
    key: Curry._1(ProductDetailsConfigId$ApiTypes.ContentId.toString, id)
  });
}
function renderEnhance(product, elementId, config) {
  return React.createElement(MakerPage$Showside.make, {
    config: config,
    elementId: elementId,
    product: product
  });
}
function renderDynamicSource(style, classNameOpt, product, variant, data) {
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var field = data.source;
  var renderer;
  switch (field.TAG | 0) {
    case /* ProductData */0:
      renderer = resolveProductData(field._0, product, variant);
      break;
    case /* MetaData */1:
      renderer = resolveMetaData(field._0, product, variant);
      break;
    case /* CustomLabel */2:
      renderer = resolveCustomLabel(field._0, variant);
      break;
    case /* Availability */3:
      renderer = resolveAvailability(field._0, product, variant);
      break;
  }
  return Belt_Option.map(Belt_Option.map(renderer, function (fn) {
    return Curry._6(fn, data.isRichText, data.isPreWrapped, className, style, product, variant);
  }), function (element) {
    return renderContentFragment(data.id, element);
  });
}
function renderTable(classNameOpt, product, variant, style, rows) {
  var renderCellContent = function (cellContent) {
    if (cellContent.TAG === /* DynamicSource */0) {
      return renderDynamicSource({}, undefined, product, variant, cellContent._0);
    }
    var match = cellContent._0;
    return Caml_option.some(renderContentFragment(match.id, renderText(match.isRichText, match.isPreWrapped, "", {}, product, variant, match.text)));
  };
  var renderRow = function (i, columns) {
    var columnContent = Belt_Array.map(columns, renderCellContent);
    var everyText = Belt_Array.every(columns, function (_type) {
      if (_type.TAG === /* DynamicSource */0) {
        return false;
      } else {
        return true;
      }
    });
    var someResolvedDynamicSource = Belt_Array.some2(columnContent, columns, function (content, _type) {
      if (_type.TAG === /* DynamicSource */0) {
        return Belt_Option.isSome(content);
      } else {
        return false;
      }
    });
    var willRender = everyText || someResolvedDynamicSource;
    if (willRender) {
      return Caml_option.some(style >= 2 ? React.createElement("div", {
        key: String(i)
      }, Belt_Array.mapWithIndex(Belt_Array.keepMap(columnContent, function (a) {
        return a;
      }), function (j, cell) {
        return React.createElement("span", {
          key: String(i) + "-" + String(j),
          className: CSS$Showside.prefix("inline-block mr-2")
        }, cell);
      })) : React.createElement("tr", {
        key: String(i)
      }, Belt_Array.mapWithIndex(Belt_Array.keepMap(columnContent, function (a) {
        if (style !== 1) {
          return Caml_option.some(Belt_Option.getWithDefault(a, "-"));
        } else {
          return a;
        }
      }), function (j, cell) {
        return React.createElement("td", {
          key: String(i) + "-" + String(j),
          className: CSS$Showside.prefix(Cn.make(["p-4 border-collapse", style !== 0 ? "" : "border border-tertiary"]))
        }, cell);
      })));
    }
  };
  var rows$1 = Belt_Array.keepMap(Belt_Array.mapWithIndex(rows, renderRow), function (a) {
    return a;
  });
  if (rows$1.length !== 0) {
    return Caml_option.some(React.createElement("table", {
      className: CSS$Showside.prefix(Cn.make(["w-full table-fixed border-collapse", style !== 0 ? "block" : "border border-tertiary"]))
    }, style !== 1 ? rows$1 : React.createElement("tbody", {
      className: CSS$Showside.prefix("block overflow-auto px-6")
    }, rows$1)));
  }
}
function renderJavaScript(id, product, variant, code) {
  var match = code.trim();
  if (match === "") {
    return;
  } else {
    return Belt_Option.map(Belt_Option.keep(CustomScript$Showside.triggerCustomFunctionReturningString(code, product, variant, "PDP content", undefined, undefined), function (string) {
      return string.trim() !== "";
    }), function (string) {
      return renderText(true, false, "", {}, product, variant, string);
    });
  }
}
function renderContent(styleOpt, classNameOpt, product, variant, config, visible, content) {
  var style = styleOpt !== undefined ? Caml_option.valFromOption(styleOpt) : {};
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var isVisible$1 = isVisible(product, variant, visible);
  if (!isVisible$1) {
    return;
  }
  switch (content.TAG | 0) {
    case /* DynamicSource */0:
      return renderDynamicSource(style, className, product, variant, content._0);
    case /* Text */1:
      var match = content._0;
      return Caml_option.some(renderContentFragment(match.id, renderText(match.isRichText, match.isPreWrapped, className, style, product, variant, match.text)));
    case /* Image */2:
      var image = content._0;
      var field = image.source;
      var src;
      switch (field.TAG | 0) {
        case /* URL */0:
          src = field._0;
          break;
        case /* MetaData */1:
          src = Product$Showside.Metadata.getMetadataAsText(product, Belt_Option.getWithDefault(variant, product.firstVariant), field._0);
          break;
        case /* CustomLabel */2:
          src = getCustomLabelText(field._0, variant);
          break;
      }
      var match$1 = image.altText;
      var altText;
      if (match$1 !== undefined) {
        switch (match$1.TAG | 0) {
          case /* Text */0:
            altText = match$1._0;
            break;
          case /* MetaData */1:
            altText = Product$Showside.Metadata.getMetadataAsText(product, Belt_Option.getWithDefault(variant, product.firstVariant), match$1._0);
            break;
          case /* CustomLabel */2:
            altText = getCustomLabelText(match$1._0, variant);
            break;
        }
      } else {
        altText = undefined;
      }
      return renderImage(src, altText);
    case /* Enhance */3:
      return Caml_option.some(renderEnhance(product, Curry._1(ProductDetailsConfigId$ApiTypes.ContentId.toString, content._0.id), config));
    case /* Table */4:
      var match$2 = content._0;
      return renderTable(className, product, variant, match$2.style, match$2.cells);
    case /* JavaScript */5:
      var match$3 = content._0;
      return renderJavaScript(Curry._1(ProductDetailsConfigId$ApiTypes.ContentId.toString, match$3.id), product, variant, match$3.code);
  }
}
function renderContents(classNameOpt, product, variant, config, visible, contents) {
  var className = classNameOpt !== undefined ? classNameOpt : "";
  var partial_arg = className;
  return Belt_Array.keepMap(Belt_Array.map(contents, function (param) {
    return renderContent(undefined, partial_arg, product, variant, config, visible, param);
  }), function (a) {
    return a;
  });
}
var Content = {
  DynamicSource: DynamicSource,
  $$Image: $$Image,
  Table: Table,
  getId: getId,
  getDynamicSource: getDynamicSource,
  getImageSource: getImageSource,
  getImageAltTextSource: getImageAltTextSource,
  renderText: renderText,
  renderTextList: renderTextList,
  resolveMetaData: resolveMetaData,
  resolveProductData: resolveProductData,
  getCustomLabelText: getCustomLabelText,
  resolveCustomLabel: resolveCustomLabel,
  resolveAvailability: resolveAvailability,
  renderImage: renderImage,
  renderContentFragment: renderContentFragment,
  renderEnhance: renderEnhance,
  renderDynamicSource: renderDynamicSource,
  renderTable: renderTable,
  renderJavaScript: renderJavaScript,
  renderContent: renderContent,
  renderContents: renderContents
};
function renderContent$1(style, className, product, variant, config, t) {
  return renderContent(style, className, product, variant, config, t.visible, t.content);
}
var SummarySection = {
  renderContent: renderContent$1
};
function renderContents$1(className, product, variant, config, t) {
  return renderContents(className, product, variant, config, t.visible, t.contents);
}
var DetailedSection = {
  renderContents: renderContents$1
};
var empty_id = Curry._1(ProductDetailsConfigId$ApiTypes.SectionId.fromString, "");
var empty_contents = [];
var empty = {
  id: empty_id,
  contents: empty_contents,
  title: "",
  visible: /* Hidden */1
};
function renderContents$2(className, product, variant, config, t) {
  return renderContents(className, product, variant, config, t.visible, t.contents);
}
var PromoSection = {
  empty: empty,
  renderContents: renderContents$2
};
function renderContent$2(className, product, variant, config, t) {
  return renderContent(undefined, className, product, variant, config, t.visible, t.content);
}
var PriceLabel = {
  renderContent: renderContent$2
};
var empty_id$1 = Curry._1(ProductDetailsConfigId$ApiTypes.SectionId.fromString, "");
var empty_content = {
  TAG: /* Text */1,
  _0: {
    id: Curry._1(ProductDetailsConfigId$ApiTypes.ContentId.fromString, ""),
    text: "",
    isRichText: false,
    isPreWrapped: false
  }
};
var empty$1 = {
  id: empty_id$1,
  content: empty_content,
  title: "",
  visible: /* Hidden */1,
  backgroundColor: "#000000",
  textColor: "#ffffff"
};
function renderContent$3(style, className, product, variant, config, t) {
  return renderContent(style, className, product, variant, config, t.visible, t.content);
}
var Badge = {
  empty: empty$1,
  renderContent: renderContent$3
};
function renderContent$4(style, className, isMobile, product, variant, config, t) {
  var mobileContent = t.mobileContent;
  var content = mobileContent !== undefined && isMobile ? mobileContent : t.content;
  return renderContent(style, className, product, variant, config, t.visible, content);
}
var EnhanceSection = {
  renderContent: renderContent$4
};
var empty_summarySections = [];
var empty_detailedSections = [];
var empty_promoSections = [];
var empty_enhanceSections = [];
var empty_badges = [];
var empty_reviews = [];
var empty_priceLabels = [];
var empty$2 = {
  summarySections: empty_summarySections,
  detailedSections: empty_detailedSections,
  promoSection: empty,
  promoSections: empty_promoSections,
  enhanceSection: undefined,
  enhanceSections: empty_enhanceSections,
  badges: empty_badges,
  reviews: empty_reviews,
  priceLabels: empty_priceLabels
};
function makeDefault(settings, product, variant) {
  var description = Belt_Option.orElse(Belt_Option.flatMap(variant, function (v) {
    return v.description;
  }), product.description);
  var shipping = settings.shipping;
  var detailedSections = [description !== undefined ? {
    id: Curry._1(ProductDetailsConfigId$ApiTypes.SectionId.fromString, "description"),
    contents: [{
      TAG: /* Text */1,
      _0: {
        id: Curry._1(ProductDetailsConfigId$ApiTypes.ContentId.fromString, "description-content"),
        text: description,
        isRichText: true,
        isPreWrapped: false
      }
    }],
    accordionState: /* DefaultState */0,
    title: "Description",
    iconUrl: "",
    visible: /* Visible */0
  } : undefined, shipping !== undefined ? {
    id: Curry._1(ProductDetailsConfigId$ApiTypes.SectionId.fromString, "shipping"),
    contents: [{
      TAG: /* Text */1,
      _0: {
        id: Curry._1(ProductDetailsConfigId$ApiTypes.ContentId.fromString, "shipping-content"),
        text: shipping,
        isRichText: true,
        isPreWrapped: false
      }
    }],
    accordionState: /* DefaultState */0,
    title: "Shipping & Returns",
    iconUrl: "",
    visible: /* Visible */0
  } : undefined];
  var arrival = settings.arrival;
  var shippingShort = settings.shippingShort;
  var summarySections = [{
    id: Curry._1(ProductDetailsConfigId$ApiTypes.SectionId.fromString, "availability"),
    content: {
      TAG: /* Text */1,
      _0: {
        id: Curry._1(ProductDetailsConfigId$ApiTypes.ContentId.fromString, "availability-content"),
        text: variant !== undefined ? variant.availability ? "In Stock" : "Out of Stock" : Product$Showside.isOutOfStock(product) ? "Out of Stock" : "In Stock",
        isRichText: false,
        isPreWrapped: false
      }
    },
    title: "Availability",
    iconUrl: "",
    visible: /* Visible */0
  }, arrival !== undefined ? {
    id: Curry._1(ProductDetailsConfigId$ApiTypes.SectionId.fromString, "arrival"),
    content: {
      TAG: /* Text */1,
      _0: {
        id: Curry._1(ProductDetailsConfigId$ApiTypes.ContentId.fromString, "arrival-content"),
        text: arrival,
        isRichText: false,
        isPreWrapped: false
      }
    },
    title: "arrival",
    iconUrl: "",
    visible: /* Visible */0
  } : undefined, shippingShort !== undefined ? {
    id: Curry._1(ProductDetailsConfigId$ApiTypes.SectionId.fromString, "shippingShort"),
    content: {
      TAG: /* Text */1,
      _0: {
        id: Curry._1(ProductDetailsConfigId$ApiTypes.ContentId.fromString, "shippingShort-content"),
        text: shippingShort,
        isRichText: false,
        isPreWrapped: false
      }
    },
    title: "shippingShort",
    iconUrl: "",
    visible: /* Visible */0
  } : undefined];
  var promoText = settings.pdpPromoText;
  var promoSection = promoText !== undefined ? {
    id: Curry._1(ProductDetailsConfigId$ApiTypes.SectionId.fromString, "promo"),
    contents: [{
      TAG: /* Text */1,
      _0: {
        id: Curry._1(ProductDetailsConfigId$ApiTypes.ContentId.fromString, "promo-content"),
        text: promoText,
        isRichText: true,
        isPreWrapped: false
      }
    }],
    title: "promo",
    visible: /* Visible */0
  } : {
    id: Curry._1(ProductDetailsConfigId$ApiTypes.SectionId.fromString, "promo"),
    contents: [{
      TAG: /* Text */1,
      _0: {
        id: Curry._1(ProductDetailsConfigId$ApiTypes.ContentId.fromString, "promo-content"),
        text: "",
        isRichText: true,
        isPreWrapped: false
      }
    }],
    title: "promo",
    visible: /* Hidden */1
  };
  var prefix = settings.pdpPricePrefixText;
  var suffix = settings.pdpPriceSuffixText;
  var priceLabels = [prefix !== undefined ? {
    id: Curry._1(ProductDetailsConfigId$ApiTypes.SectionId.fromString, "pricePrefix"),
    title: "pricePrefix",
    visible: /* Visible */0,
    visibleInProductCard: false,
    showAs: /* Prefix */0,
    content: {
      TAG: /* Text */1,
      _0: {
        id: Curry._1(ProductDetailsConfigId$ApiTypes.ContentId.fromString, "pricePrefix-content"),
        text: prefix,
        isRichText: false,
        isPreWrapped: false
      }
    }
  } : undefined, suffix !== undefined ? {
    id: Curry._1(ProductDetailsConfigId$ApiTypes.SectionId.fromString, "priceSuffix"),
    title: "priceSuffix",
    visible: /* Visible */0,
    visibleInProductCard: false,
    showAs: /* Suffix */1,
    content: {
      TAG: /* Text */1,
      _0: {
        id: Curry._1(ProductDetailsConfigId$ApiTypes.ContentId.fromString, "priceSuffix-content"),
        text: suffix,
        isRichText: false,
        isPreWrapped: false
      }
    }
  } : undefined];
  return {
    summarySections: Belt_Array.keepMap(summarySections, function (a) {
      return a;
    }),
    detailedSections: Belt_Array.keepMap(detailedSections, function (a) {
      return a;
    }),
    promoSection: promoSection,
    promoSections: [promoSection],
    enhanceSection: undefined,
    enhanceSections: [],
    badges: [],
    reviews: [],
    priceLabels: Belt_Array.keepMap(priceLabels, function (a) {
      return a;
    })
  };
}
var ContentId;
var SectionId;
export { ContentId, SectionId, Visible, isVisible, Content, SummarySection, DetailedSection, PromoSection, PriceLabel, Badge, EnhanceSection, empty$2 as empty, makeDefault };
/* empty Not a pure module */